export enum BlobEntityType {
    PurchaseOrder = 1,
    PurchaseOrderLineItem = 2,
    Recordable = 3
}
